var ABTest = /** @class */ (function () {
    function ABTest(experiments, getCurrentURL) {
        this.experiments = experiments;
        this.url = getCurrentURL ? getCurrentURL() : this._getCurrentURL();
    }
    ABTest.prototype.run = function () {
        this.experiments.forEach(function (experiment) {
            experiment.run();
        });
    };
    ABTest.prototype._getCurrentURL = function () {
        if (typeof window !== "undefined") {
            return window.location.pathname + window.location.search;
        }
        return null;
    };
    return ABTest;
}());
export default ABTest;
